// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:57:38

export default {
  "id": "baling-bum",
  "slug": "baling-bum",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f8d07e383172448792902f5d87243403-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f8d07e383172448792902f5d87243403/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Baling Bum",
      "description": "Baling Bum – A Creative Rainbow Puzzle! ?☀️\nGet ready for a unique and challenging puzzle game! In Baling Bum, your mission is to move or rotate the rainbow blocks to return the sun to the clouds. As you progress, the puzzles become trickier, requiring logical thinking and strategic moves!\n\nAre you ready to bring the sun back to the sky? ☁️✨ Play Baling Bum now and put your puzzle-solving skills to the test!",
      "instructions": "Move or rotate the rainbow blocks to return the sun to the clouds",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "绑腿布",
      "description": "彩虹宝贝 - 一款创意彩虹拼图游戏！\n准备好挑战一款独特且具有挑战性的拼图游戏吧！在彩虹宝贝中，你的任务是移动或旋转彩虹方块，将太阳送回云层。随着游戏的进行，拼图变得越来越复杂，需要逻辑思考和战略性的操作！\n\n你准备好将太阳带回天空了吗？🌤️✨ 现在就玩彩虹宝贝，测试你的拼图解决能力！",
      "instructions": "移动或旋转彩虹块，将太阳送回云层",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1玩家"
      ]
    },
    "zh-TW": {
      "title": "拔營屁股",
      "description": "巴林布姆 – 一款創意彩虹拼圖！?☀️\n準備好迎接一場獨特且挑戰性的拼圖遊戲！在巴林布姆中，你的任務是移動或旋轉彩虹塊，將太陽送回雲彩中。隨著遊戲進行，拼圖會變得越來越複雜，需要邏輯思考和策略性的動作！\n\n你準備好將太陽帶回天空了嗎？☁️✨ 現在就玩巴林布姆，挑戰你的解謎技巧！",
      "instructions": "將彩虹塊移動或旋轉，將陽光送回雲層",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1 玩家"
      ]
    },
    "zh-HK": {
      "title": "搬運臀",
      "description": "巴林布姆 – 一款創意彩虹益智遊戲！?☀️\n準備好迎接一款獨特且挑戰性的益智遊戲！在巴林布姆中，你的任務是移動或旋轉彩虹塊，將太陽送回雲彩。隨著進度推進，遊戲難度逐漸增加，需要邏輯思考及策略性操作！\n\n你準備好將太陽帶回天空嗎？☁️✨ 現在就玩巴林布姆，檢驗你的解謎技巧！",
      "instructions": "移動或旋轉彩虹塊，將太陽送回雲彩中",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "ja": {
      "title": "バリンブーム",
      "description": "バリングバム – クリエイティブな虹のパズル！?☀️\nユニークで挑戦的なパズルゲームに備えてください！バリングバムであなたのミッションは、虹のブロックを動かしたり回転させ、太陽を雲に戻すことです。進むにつれて、パズルはより難しくなり、論理的な思考と戦略的な動きが必要になります！\n\n太陽を空に戻す準備はできましたか？☁️✨今すぐバリングバムをプレイして、パズル解決能力を試してみましょう！",
      "instructions": "虹のブロックを移動または回転して、太陽を雲に戻します。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "발링럼",
      "description": "발링똘름 – 창의적인 다리빛 퍼즐! ?☀️\n독특하고 도전적인 퍼즐 게임을 준비하세요! 발링똘름에서의 임무는 햇살을 구름으로 돌려보내는 것입니다. 진행할수록 퍼즐이 더 어려워지며, 논리적 사고와 전략적인 움직임이 필요합니다!\n\n햇살을 하늘로 돌려보내기 위해 준비가 되셨나요? ☁️✨ 지금 바로 발링똘름을 플레이하고 퍼즐 해결 능력을 테스트해보세요!",
      "instructions": "레인보우 블록을 이동하거나 회전시켜 태양을 구름으로 돌려보세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Balancement de fesses",
      "description": "Baling Bum – Un puzzle arc-en-ciel créatif ! ?☀️\nPréparez-vous à un jeu de puzzle unique et stimulant ! Dans Baling Bum, votre mission est de déplacer ou de rotationner les blocs arc-en-ciel pour ramener le soleil aux nuages. Au fur et à mesure que vous avancez, les puzzles deviennent plus difficiles, nécessitant une pensée logique et des mouvements stratégiques !\n\nPrêt à ramener le soleil dans le ciel ? ☁️✨ Jouez à Baling Bum maintenant et mettez vos compétences de résolution de puzzles à l'épreuve !",
      "instructions": "Déplacez ou tournez les blocs arc-en-ciel pour ramener le soleil aux nuages",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
